module.exports = __webpack_public_path__ + "img/C06TechTotalWar_ua.90a818c3.webp";